import './label.scss';

const Label = ({ children }) => {
    return <div className="label body3">{children}</div>;
};

export default Label;
